<template>
  <div>
    <preview-job-comments
      :comments="commentHighlights"
      :is-show="isShowComment"
      v-on="$listeners"
    />
    <div
      v-if="isShowTextCount"
      class="pega-count-moji-area"
    >
      <template v-for="(photo,i) in photos">
        <preview-text-count
          v-if="photo.caption.value"
          :key="i"
          :name="'写真キャプション(' + positionStrings[i] + ')'"
          :count-target="photo.caption"
        />
      </template>
    </div>
    <ul
      class="three_pic_area clearfix"
    >
      <template v-for="(photo,i) in photos">
        <li
          :key="i"
          class="pull-left"
        >
          <figure class="object">
            <div class="flame">
              <img
                :id="id + '-' + (i + 1)"
                class="lazy"
                :data-test="`photo-${i + 1}`"
                :alt="photo.caption.value"
                :src="userImageUrl + photo.id"
                @load="$emit('onLoadImage')"
                @error="$emit('onLoadImage')"
              >
            </div>
            <figcaption
              :id="captionId + '-' + (i + 1)"
              class="caption pega-pre-wrap"
              :data-test="`photo-caption-${i + 1}`"
              v-text="photo.caption.value"
            />
          </figure>
        </li>
      </template>
    </ul>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/base" as *;
</style>

<script>
import PreviewJobComments from '@/components/molecules/PreviewJobComments'
import PreviewTextCount from '@/components/atoms/PreviewTextCount'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  components: {
    PreviewJobComments,
    PreviewTextCount
  },
  mixins: [jobPreviewCommon],
  props: {
    id: {
      type: String,
      required: true
    },
    captionId: {
      type: String,
      required: true
    },
    photos: {
      type: Array,
      required: true
    },
    max: {
      type: Number,
      default: 0
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    },
    isShowTextCount: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    positionStrings: () => ['左', '中', '右']
  },
  mounted () {
    this.commentHighlights.forEach((commentHighlight) => {
      this.setHighlight(commentHighlight)
    })
  }
}
</script>
